import React from 'react';
import classes from '../signup/signup.module.scss';
import { LogoContainer } from './styles';
import Svg from '@svg/index';

export default () => (
  <LogoContainer flexDirection="column" className={classes.logo}>
    <Svg name="full-logo_02" />
  </LogoContainer>
);
